<template>
	<div class="post-share">
		<div class="thumb">Compartilhe</div>
		<div class="redes">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default{
	name: 'PostShare'
}
</script>


// WEBPACK FOOTER //
// src/assets/vue/components/Post/PostShare.vue